import React, { useState } from "react";
import {
  Divider,
  makeStyles,
  Typography,
  Checkbox,
  Box,
} from "@material-ui/core";
import ReactECharts from "echarts-for-react";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Text from "../../components/Text";
import { DateInput } from "../../components/Form";
import Grid from "../../components/Grid";
import Button from "../../components/Button";

export default function CustomerAnalyzeTable() {
  const data = [];
  const [newData, setNewData] = useState({
    wish: false,
    dateStart: null,
    dateEnd: null,
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });
  //統計圖
  // const getOption = () => {
  //   if (history.location.state) {
  //     return ({
  //       title: {
  //         text: (history.location.state.rangeObject && history.location.state.rangeObject.label) +
  //           ":" + (history.location.state.auctionQuotesObject && history.location.state.auctionQuotesObject.label),
  //         x: "center"
  //       },
  //       tooltip: {
  //         trigger: "item",
  //         formatter: "{a} <br/>{b} : {c} ({d}%)"
  //       },
  //       series: [
  //         {
  //           name: "來源",
  //           type: "pie",
  //           radius: "55%",
  //           center: ["50%", "60%"],
  //           animationDuration: 5000,
  //           data: history.location.state.selectData,
  //           itemStyle: {
  //             emphasis: {
  //               shadowBlur: 10,
  //               shadowOffsetX: 0,
  //               shadowColor: "rgba(0, 0, 0, 0.5)"
  //             }
  //           }
  //         }
  //       ]
  //     })
  //   }
  // };
  // const Option = () => {
  //   if (history.location.state) {
  //     return ({
  //       xAxis: {
  //         type: 'category',
  //         data: history.location.state.selectData.map((item) => { return item.name })
  //       },
  //       yAxis: {
  //         type: 'value'
  //       },
  //       series: [{
  //         data: history.location.state.selectData.map((item) => { return item.value }),
  //         type: 'bar'
  //       }]
  //     })
  //   }
  // };

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
    DocumentContainerCenter: {
      display: "flex",
      alignItems: "center",
    },
  });
  const classes = useStyles();

  const statisticsData = [];

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid
            item
            xs={5}
            sm={2}
            classes={{ root: classes.DocumentContainerCenter }}
          >
            <Checkbox
              color="primary"
              checked={newData.wish}
              onChange={() => {
                changeData("wish", !newData.wish, true);
              }}
            />
            <Typography color="primary" style={{ fontSize: 15 }}>
              意願A
            </Typography>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={10} sm={4}>
              <Box display="flex" flexDirection="row" alignItems="flex-end">
                <Box display="flex" flexDirection="column">
                  <Typography color="primary" style={{ fontSize: 15 }}>
                    自訂日期
                  </Typography>
                  <DateInput
                    format="yyyy年MM月dd日"
                    value={newData.dateStart}
                    onChange={(v) => changeData("dateStart", v, true)}
                    fullWidth
                  />
                </Box>
                <Typography color="primary">～</Typography>
                <Grid item classes={{ root: classes.DocumentContainerEnd }}>
                  <DateInput
                    format="yyyy年MM月dd日"
                    value={newData.dateEnd}
                    minDate={newData.dateStart}
                    onChange={(v) => changeData("dateEnd", v, true)}
                    fullWidth
                  />
                </Grid>
              </Box>
            </Grid>
            <Grid
              item
              xs={2}
              classes={{ root: classes.DocumentContainerButtonEnd }}
            >
              <Button size="small" color="primary" variant="contained">
                確定
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <Table
          data={data}
          tableWidth={2}
          header={[
            "人員/統計",
            "總計/人",
            "未處理/人",
            "加盟數/人",
            "已付加盟訂金/人",
            "已上課/人",
            "已付上課訂金/人",
            "未上課/人",
            "面談數/次",
            "電訪數/次",
          ]}
          columns={[
            (item) => <Text>{item.code}</Text>,
            (item) => <Text>{item.numberDebtor}</Text>,
            (item) => <Text>{item.address}</Text>,
            (item) => <Text>{item.date}</Text>,
            (item) => <Text>{item.status}</Text>,
            (item) => <Text>{item.floor}</Text>,
            (item) => <Text>{item.floorMillion}</Text>,
          ]}
        />
      </CardContent>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <Table data={statisticsData} />
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <ReactECharts
            option={getOption()}
            /> */}
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <Grid container spacing={1}>
          {/* <ReactECharts
          option={Option()}
          /> */}
        </Grid>
      </CardContent>
    </Card>
  );
}
